import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ReachMenu, ReachMenuList, ReachMenuButton } from "./menu-button-pieces";
import Icon from "./icon";
import ActionsMenuItem from "./actions-menu-item";

const ActionsMenu = ({ trigger, options, menuClassName, triggerClassName, title, disabled }) => {
  const [mounted_item, setMountedItem] = useState();
  const isGroupedOptions = options.length && options[0].items;

  return (
    <>
      <ReachMenu>
        {({ isOpen }) => (
          <>
            <ReachMenuButton
              disabled={disabled}
              title={title}
              className={classNames(
                {
                  "et--actions-menu--trigger et--button-action": !trigger,
                  "et--plain-button": trigger,
                },
                triggerClassName
              )}
            >
              {typeof trigger === "function" ? (
                trigger({ isOpen, disabled })
              ) : (
                <span>
                  Actions...
                  <Icon icon={isOpen ? "chevron-up" : "chevron-down"} />
                </span>
              )}
            </ReachMenuButton>
            <ReachMenuList className={classNames("et--actions-menu--menu", menuClassName)}>
              {options.map((option) => {
                return isGroupedOptions ? (
                  <div key={option.id} className="et--actions-menu--option-group">
                    {option.heading && <div className="et--actions-menu--option-heading">{option.heading}</div>}
                    {option.items.map((item) => (
                      <ActionsMenuItem key={item.id} option={item} setMountedItem={setMountedItem} />
                    ))}
                  </div>
                ) : (
                  <ActionsMenuItem key={option.id} option={option} setMountedItem={setMountedItem} />
                );
              })}
            </ReachMenuList>
          </>
        )}
      </ReachMenu>
      {mounted_item && mounted_item}
    </>
  );
};

ActionsMenu.propTypes = {
  /**
   * An array of options with the following properties. Note id is important for the option key.
   * { id, title, icon, iconStyle, label, description, disabled, href, as, target, mountOnClick, onClick }
   */
  options: PropTypes.array.isRequired,
  /**
   * To a render prop for a trigger element other than the default action button. isOpen and disabled will be passed to this function
   */
  trigger: PropTypes.func,
  /**
   * Classname for trigger
   */
  triggerClassName: PropTypes.string,
  /**
   * Title for action button
   */
  title: PropTypes.string,
  /**
   * Classname for dropdown menu
   */
  menuClassName: PropTypes.string,
  /**
   * Disable action button
   */
  disabled: PropTypes.bool,
};

export default ActionsMenu;
